import client from '../../shared/api/client';
import { Admin, LoginResponse } from '../../shared/types';

export const login = async (email: string, password: string): Promise<LoginResponse> => {
  const response = await client.post<LoginResponse>('/auth/login', { email, password });
  return response.data;
};

export const logout = async (): Promise<void> => {
  await client.post('/auth/logout');
};

export const getMe = async (): Promise<Admin> => {
  const response = await client.get<Admin>('/auth/me');
  return response.data;
};
